// FETCH ALL FABRIC_MASTER
export const FETCH_FABRIC_MASTER_REQUEST = 'FETCH_FABRIC_MASTER_REQUEST';
export const FETCH_FABRIC_MASTER_SUCCESS = 'FETCH_FABRIC_MASTER_SUCCESS';
export const FETCH_FABRIC_MASTER_FAILURE = 'FETCH_FABRIC_MASTER_FAILURE';

export const FETCH_FABRIC_MASTER_YARN_MATERIAL_REQUEST = 'FETCH_FABRIC_MASTER_YARN_MATERIAL_REQUEST';
export const FETCH_FABRIC_MASTER_YARN_MATERIAL_SUCCESS = 'FETCH_FABRIC_MASTER_YARN_MATERIAL_SUCCESS';
export const FETCH_FABRIC_MASTER_YARN_MATERIAL_FAILURE = 'FETCH_FABRIC_MASTER_YARN_MATERIAL_FAILURE';

// CREATE FABRIC_MASTER
export const CREATE_FABRIC_MASTER_REQUEST = 'CREATE_FABRIC_MASTER_REQUEST';
export const CREATE_FABRIC_MASTER_SUCCESS = 'CREATE_FABRIC_MASTER_SUCCESS';
export const CREATE_FABRIC_MASTER_FAILURE = 'CREATE_FABRIC_MASTER_FAILURE';

// FETCH SINGLE PART DATA
export const FETCH_SINGLE_FABRIC_MASTER_REQUEST = 'FETCH_SINGLE_FABRIC_MASTER_REQUEST';
export const FETCH_SINGLE_FABRIC_MASTER_SUCCESS = 'FETCH_SINGLE_FABRIC_MASTER_SUCCESS';
export const FETCH_SINGLE_FABRIC_MASTER_FAILURE = 'FETCH_SINGLE_FABRIC_MASTER_FAILURE';

// UPDATE FABRIC_MASTER
export const UPDATE_FABRIC_MASTER_REQUEST = 'UPDATE_FABRIC_MASTER_REQUEST';
export const UPDATE_FABRIC_MASTER_SUCCESS = 'UPDATE_FABRIC_MASTER_SUCCESS';
export const UPDATE_FABRIC_MASTER_FAILURE = 'UPDATE_FABRIC_MASTER_FAILURE';

// DELETE FABRIC_MASTER
export const DELETE_FABRIC_MASTER_REQUEST = 'DELETE_FABRIC_MASTER_REQUEST';
export const DELETE_FABRIC_MASTER_SUCCESS = 'DELETE_FABRIC_MASTER_SUCCESS';
export const DELETE_FABRIC_MASTER_FAILURE = 'DELETE_FABRIC_MASTER_FAILURE';

// FETCH ALL FABRIC_MASTER
export const FETCH_FABRIC_MASTER_WITH_YARN_GROUP_REQUEST = 'FETCH_FABRIC_MASTER_WITH_YARN_GROUP_REQUEST';
export const FETCH_FABRIC_MASTER_WITH_YARN_GROUP_SUCCESS = 'FETCH_FABRIC_MASTER_WITH_YARN_GROUP_SUCCESS';
export const FETCH_FABRIC_MASTER_WITH_YARN_GROUP_FAILURE = 'FETCH_FABRIC_MASTER_WITH_YARN_GROUP_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER

export const RESET_FABRIC_MASTER_INFO = 'RESET_FABRIC_MASTER_INFO';

export const CREATE_FABRIC_MASTER_FORM = 'CREATE_FABRIC_MASTER_FORM';

export const UPDATE_FABRIC_MASTER_FORM = 'UPDATE_FABRIC_MASTER_FORM';
